module.exports = __webpack_public_path__ + "img/5-min.1599fe4d.jpg";